module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "d-flex ai-center jc-center",
    class: {
      'fd-column': _vm.isMovil
    },
    attrs: {
      "height": "calc(100vh - 112px)",
      "color": "background"
    }
  }, _vm._l((_vm.items), function(r, index) {
    return _c('v-card', {
      key: index,
      staticClass: "pa-2 ma-4",
      attrs: {
        "name": index,
        "id": _vm.items.length - 1,
        "color": r.id === _vm.indexItems ? 'primary white--text' : '',
        "to": r.path,
        "height": "100",
        "width": "300",
        "hover": "hover"
      }
    }, [_c('div', {
      staticClass: "d-flex ai-center"
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "57",
        "color": "primary"
      }
    }, [_vm._v(_vm._s(r.icon))]), _c('div', {
      staticClass: "flex-1 d-flex fd-column"
    }, [_c('span', {
      staticClass: "font-weight-700 font-size-20",
      class: {
        'font-size-17': _vm.isMovil
      }
    }, [_vm._v(_vm._s(r.title))]), _c('small', {
      staticClass: "font-size-12",
      class: {
        'white--text': r.id === _vm.indexItems
      }
    }, [_vm._v(_vm._s(r.descripcion))])])], 1)])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59608f86","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_manager.vue
// module id = 501
// module chunks = 1